import { Link as DigdirLink, } from "@digdir/designsystemet-react";
const Link = DigdirLink;
Link.displayName = "Link";
export { Link };
//# sourceMappingURL=link.js.map